<template>
  <div class="vz-multi-order-request-list pdf-order-section">
    <div class="vz-individual-order-directions-title text-h1 mb-20 vz-multi-order-request-list-title">
      Заявки
<!--      <div>i</div>-->
<!--      todo-->
      <vz-button
        v-if="!multiOrder.locked"
        big
        outline
        icon-name="plus"
        variant="primary"
        class="ml-auto"
        @click="addRequest()"
      >Добавить адрес</vz-button>
    </div>
    <div class="vz-multi-order-request-list-grid">
      <vz-multi-order-request-card
        v-for="(order, index) of multiOrder.requestList"
        :order="order"
        :index="index + 1"
        :guid="order.meta.id"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {useOrderStore} from '~/stores/order';
import VzButton from '~/components/ui-kit/vz-button.vue';
import VzMultiOrderRequestCard from '~/components/personal/order/multi-order/vz-multi-order-request-card.vue';
import {scrollToElem} from "~/common/functions";

const {multiOrder, getOrderPriceAction} = useOrderStore()

const validateOrderForm: Function = inject('validateOrderForm', () => {})

async function addRequest() {
  if (await validateOrderForm()) {
    multiOrder.addRequest()
    getOrderPriceAction()
    await nextTick()
    scrollToElem('.vz-individual-order-header', { behavior: 'smooth', block: 'start' });
  }
}
</script>

<style lang="scss" scoped>
.vz-multi-order-request-list {
  &-title {
    display: flex;
  }
  &-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 35px;
    row-gap: 20px;

    @media screen and (max-width: $pub-md) {
      column-gap: 27px;
    }

    @media screen and (max-width: $pa-sm) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
